/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCopy } from "@fortawesome/free-solid-svg-icons";
import { Row, Modal, ModalHeader, ModalBody, Button } from "reactstrap";
import { WhatsappIcon } from "react-share";
import { isFirefox, isIOS, isMobile } from "react-device-detect";
import { connect } from "react-redux";
import { serverResponse } from "../../util/fakeServer";
import { styles } from "./ShareGroceryListBtn.style";
import { NotificationManager } from "react-notifications";
import {
  defaultLanguage,
  getLocalStore,
  idParamUrlGenerator
} from "../../helper/utility";
import { language } from "../../languageProvider/language/language";
import { checkCartValidity } from "../../redux/cart/action";
import * as services from "../../services/grocery_list.services";

class ShareGroceryList extends Component {
  state = {
    modal: false
  };

  link = () => {
    const cloned_param_url = sessionStorage.getItem("cloned_param_url");
    return `${process.env.REACT_APP_SHARE_URL}cart/${cloned_param_url}`;
  };

  whatsappHandler = () => {
    let title = language[defaultLanguage].visualizza_lista_spesa;
    let str = title + "    " + this.link();
    const hiddenLink = document.getElementById("hidden_link");

    const linkToShare = isMobile
      ? `whatsapp://send?text=${str}`
      : `https://wa.me/send?text=${str}`;
    hiddenLink.setAttribute("href", linkToShare);
    hiddenLink.click();
  };

  mailHandler = () => {
    let target = "_self";
    if (isFirefox) target = "_blank";
    window.open(`mailto:?body=${this.link()}`, target);
  };

  copyHandler = () => {
    navigator.clipboard
      .writeText(this.link())
      .then(() => {
        NotificationManager.success(
          language[defaultLanguage].elemento_copiato,
          language[defaultLanguage].link_copiato_negli_appunti,
          1000
        );
      })
      .catch((err) => {
        NotificationManager.error(
          language[defaultLanguage].errore_nella_copia,
          language[defaultLanguage].link_non_copiato,
          1000
        );
      });
  };

  cloneServicesHandler = (callback) => {
    const localStore = getLocalStore();

    const cloned_param_url = sessionStorage.getItem("cloned_param_url");

    services
      .cloneCart({
        new_id_param_url: cloned_param_url,
        clone_id_param_url: localStore
      })
      .then((res) => {
        const { data } = res;
        if (data.status === 200) {
          sessionStorage.setItem("isCloneable", "0");

          callback();
        }
      })
      .catch((err) => {
        alert(
          "Si è verificato un errore imprevisto, ti preghiamo di riprovare"
        );
      });
  };

  openReactNativeShare = () => {
    const isCloneable = sessionStorage.getItem("isCloneable");
    isCloneable === "1"
      ? this.cloneServicesHandler(this.whatsappHandler)
      : this.whatsappHandler();
  };

  shareMail = () => {
    const isCloneable = sessionStorage.getItem("isCloneable");
    isCloneable === "1"
      ? this.cloneServicesHandler(this.mailHandler)
      : this.mailHandler();
  };

  copyToClip = () => {
    const isCloneable = sessionStorage.getItem("isCloneable");
    isCloneable === "1"
      ? this.cloneServicesHandler(this.copyHandler)
      : this.copyHandler();
  };

  openModal = () => {
    this.setState({ modal: true });
  };

  closeModal = () => {
    this.setState({ modal: false });
  };

  render() {
    // let title = language[defaultLanguage].visualizza_lista_spesa;

    let wa1 = "inline";
    // let wa2 = "none";

    if (window.ReactNativeWebView !== undefined && isIOS) {
      wa1 = "none";
      // wa2 = "inline";
    }

    const shareButtonStyle =
      this.props.cartReducer.cart.length === 0
        ? {
            color: "white",
            fontWeight: "bold",
            display: "flex",
            justifyContent: "space-between",
            background: "grey"
          }
        : {
            color: "white",
            // padding: "10px",
            fontWeight: "bold",
            display: "flex",
            justifyContent: "space-between",
            cursor: "pointer"
          };

    let share_label = serverResponse.config.send_grocery_list_to_market
      ? language[defaultLanguage].condividi
      : language[defaultLanguage].condividi_lista;

    return (
      <div style={shareButtonStyle}>
        <Button
          onClick={(e) => {
            const isValid = this.props.checkCartValidity();
            if (isValid) {
              sessionStorage.setItem("cloned_param_url", idParamUrlGenerator());
              sessionStorage.setItem("isCloneable", "1");

              this.openModal();
            }
          }}
          outline
          style={styles.shareBtn(serverResponse.config.secondary_color)}
          className={
            this.props.cartReducer.cart.length > 0
              ? "shareButton buttonActionCart"
              : "disableButton buttonActionCart"
          }
        >
          <span>
            <i className="fas fa-share-alt">
              <span>{share_label}</span>
            </i>
          </span>
        </Button>
        <Modal
          isOpen={this.state.modal}
          toggle={() => this.closeModal()}
          centered={true}
        >
          <ModalHeader toggle={() => this.closeModal()}>
            {language[defaultLanguage].condividi_con}...
          </ModalHeader>
          <ModalBody>
            <Row
              className="custom-share-container"
              style={{ alignItems: "center" }}
            >
              {/* <FacebookShareButton
                className="facebookShareButton shareIcon"
                url={this.link()}
              >
                <FacebookIcon size={32} round={true} />
              </FacebookShareButton> */}

              {/* <TwitterShareButton
                className="twitterShareIcon shareIcon"
                title={title}
                url={this.link()}
              >
                <TwitterIcon size={32} round={true} />
              </TwitterShareButton> */}

              {/* <TelegramShareButton
                className="telegramShareIcon shareIcon"
                title={title}
                url={this.link()}
              >
                <TelegramIcon size={32} round={true} />
              </TelegramShareButton> */}

              {/* <WhatsappShareButton
                className="whatsappShareIcon shareIcon"
                title={title}
                url={this.link()}
                style={{ display: wa1 }}
              >
                <WhatsappIcon size={32} round={true} />
              </WhatsappShareButton> */}
              <a
                className="d-none"
                id="hidden_link"
                href="#"
                data-action="share/whatsapp/share"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i aria-hidden="true" />
              </a>
              <div
                className="whatsappShareIcon shareIcon"
                style={{ display: wa1 }}
                onClick={() => this.openReactNativeShare()}
              >
                <WhatsappIcon size={32} round={true} />
              </div>

              <div
                onClick={(e) => {
                  e.preventDefault();
                  this.shareMail();
                }}
                aria-label="email"
                role="button"
                tabIndex="0"
                className="SocialMediaShareButton SocialMediaShareButton--email emailShareIcon shareIcon"
              >
                <div style={{ width: "32px", height: "32px" }}>
                  <svg
                    viewBox="0 0 64 64"
                    width="32"
                    height="32"
                    className="social-icon social-icon--email "
                  >
                    <g>
                      <circle cx="32" cy="32" r="31" fill="#7f7f7f"></circle>
                    </g>
                    <g>
                      <path
                        d="M17,22v20h30V22H17z M41.1,25L32,32.1L22.9,25H41.1z M20,39V26.6l12,9.3l12-9.3V39H20z"
                        fill="white"
                      ></path>
                    </g>
                  </svg>
                </div>
              </div>

              <div
                className="copyButton shareIcon"
                onClick={() => this.copyToClip()}
                style={{
                  background: "#d94a4a",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  borderRadius: "360px",
                  width: "32px",
                  height: "32px"
                }}
              >
                <FontAwesomeIcon
                  style={{ margin: 0 }}
                  color="white"
                  size="sm"
                  icon={faCopy}
                />
              </div>
            </Row>
          </ModalBody>
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    cartReducer: state.cartReducer
  };
};

export default connect(mapStateToProps, { checkCartValidity })(
  ShareGroceryList
);
